import React from 'react'

export const FiltersComponent: React.FC = () => {
  return <>Filters</>
}
